import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

import { IonicModule } from '@ionic/angular';

import {CustomModule} from "../customs/custom.module";

import {DoctorProfileDetailModalRoutingModule} from "./doctor-profile-detail-modal-routing.module";
import {DoctorProfileDetailModalComponent} from "./doctor-profile-detail-modal.component";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    TranslateModule,    
    DoctorProfileDetailModalRoutingModule,
      CustomModule
  ],
  declarations: [DoctorProfileDetailModalComponent]
})
export class DoctorProfileDetailModalModule {}
